import _ from "lodash";
import styled, { css } from "styled-components";
import { Controller } from "react-hook-form";
import { Input } from "antd";

export const TInput = (props) => {
  return (
    <StyledContainer
      isError={props.errors && props.errors[props.name]}
      noMb={props.noMb}
      style={{ display: props.cssHide && "none" }}
    >
      {props.label && (
        <StyledLabel htmlFor={props.name}>{props.label}</StyledLabel>
      )}

      {props.option === "textarea" ? (
        <Controller
          as={
            <Input.TextArea
              hidden={props.hidden}
              id={props.name}
              rows={props.row || 2}
              size={props.size || "medium"}
              ref={props.ref}
              autoFocus={props.autoFocus}
              defaultValue={props.defaultValue}
              placeholder={props.placeholder}
              className={`styled-input ${
                props.errors && _.get(props.errors, props.name) && "input-error"
              }`}
            />
          }
          defaultValue={props.defaultValue}
          name={props.name}
          {...props.propsInput}
        />
      ) : (
        <>
          <Controller
            as={
              <Input
                hidden={props.hidden}
                addonAfter={props.addonAfter}
                id={props.name}
                ref={props.ref}
                autoFocus={props.autoFocus}
                size={props.size || "medium"}
                defaultValue={props.defaultValue}
                placeholder={props.placeholder}
                disabled={props.disabled}
                className={`styled-input ${
                  props.errors &&
                  _.get(props.errors, props.name) &&
                  "input-error"
                }`}
                prefix={props.prefix}
                suffix={props.suffix}
              />
            }
            name={props.name}
            defaultValue={props.defaultValue}
            {...props.propsInput}
          />
        </>
      )}

      <>
        {props.errors && _.get(props.errors, props.name) && (
          <>
            <StyledError>
              <p>
                {props.errors && _.get(props.errors, `${props.name}.message`)}
              </p>
            </StyledError>
          </>
        )}
      </>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${(props) => props.theme.spacing[3]};

  .styled-input {
    &.input-error,
    .input-error:focus {
      outline: none !important;
      border: ${(props) => `1px solid
          ${props.theme.colors.red[400]}`};
    }
  }
  ${(props) =>
    props.isError &&
    css`
      margin-bottom: 0;
    `};

  ${(props) =>
    props.noMb &&
    css`
      margin-bottom: 0;
    `};
`;

const StyledLabel = styled.label`
  font-weight: 500;
  color: ${(props) => props.theme.colors.grey[600]};
  margin-bottom: ${(props) => props.theme.spacing[1]};
`;

const StyledError = styled.span`
  color: ${(props) => props.theme.colors.red[600]};
  padding: 0;
  margin: 0;

  p {
    font-size: 0.8rem;
    margin: 0;
  }
`;
